import { useI18n } from 'vue-i18n'
import { Locales, Messages } from '~/plugins/2.i18n'

export function useLocale() {
  return useI18n<{ message: Messages }, Locales>()
}
